
import { UserInfo } from '@/types/user-info';
import { axiosInstance } from './req';

export const loadShareUser = async (userId: string): Promise<UserInfo[]> => {
    return axiosInstance.get(`/api/share-account/find/${userId}`).then(({ data }) => data);
};

export const inviteUser = async (userId: string, email: string): Promise<UserInfo[]> => {
    return axiosInstance.post(`/api/share-account/invite`, { userId, email }).then(({ data }) => data);
};


export const deleteInviteUser = async (userId: string): Promise<UserInfo[]> => {
    return axiosInstance.delete(`/api/share-account/remove/${userId}`).then(({ data }) => data);
};